import formatDateStringToYYMMDD from "@/queries/helpers/formatDateStringToYYMMDD"
import type EditSkiPassViewModel from "@/queries/models/EditPass"
import { PassHolderFormState } from "@/types/PassHolder"

const mapEditPassToFormState = (
  data: EditSkiPassViewModel
): PassHolderFormState => {
  const { cartItem, product, photo, certificateName } = data
  const ageGroup = product.ageGroups[0]

  return {
    id: cartItem.cartItemId,
    productPriceId: ageGroup.productId,
    passHolder: {
      id: cartItem.cartItemId,
      firstName: cartItem.firstName,
      lastName: cartItem.lastName,
      birthDate: cartItem.birthDate
        ? formatDateStringToYYMMDD(cartItem.birthDate.substring(0, 10))
        : "",
    },
    productName: product.name,
    productId: product.id,
    resortId: product.resortId,
    ageGroup: ageGroup.name,
    minAge: ageGroup.minAge,
    maxAge: ageGroup.maxAge,
    wtpNumber: cartItem.skipassNumber ?? "",
    passSelection: cartItem.skipassNumber ? "existing" : "new",
    isSubscriptionProduct: product.isSubscriptionProduct,
    isFormSubmitted: false,
    idImageRequired: product.idImageRequired,
    personCertificateRequired: product.personCertificateRequired,
    bookingLengthInDays: product.bookingLength,
    showFreeSkiDays: product.showFreeSkiDays,
    subscriptionConfigurationId: product.subscriptionConfigurationId,
    exitingPhotoId: cartItem.existingPhotoId,
    passHolderImage: photo
      ? {
          id: cartItem.existingPhotoId ?? "",
          fileName: "",
          base64: photo.data,
        }
      : undefined,
    personCertificate:
      cartItem.existingCertificateId && certificateName
        ? {
            id: cartItem.existingCertificateId,
            fileName: certificateName,
          }
        : undefined,
    analyticsName: ageGroup.analyticsName ?? undefined,
    analyticsId: ageGroup.analyticsId ?? undefined,
    memberCoupon: cartItem.mySkistarUserCoupon
      ? {
          couponCode: cartItem.mySkistarUserCoupon.couponCode,
          couponDesc: cartItem.mySkistarUserCoupon.couponDesc,
          customerId: cartItem.mySkistarUserCoupon.customerId ?? 0,
        }
      : undefined,
  }
}

export default mapEditPassToFormState
